import React, { useState } from "react";

import AssetSchemaSelect from "../../../AssetSchemaSelect";
import ImportSourceName from "../../../ImportSourceName";
import SectionMessage from "@atlaskit/section-message";
import OktaImportConfiguration from "./OktaImportConfiguration";
const OktaAssetStart = () => {
  return (
    <>
      <br />
      <SectionMessage title="Information" appearance="info">
        <p>
          Select the Asset schema and name the import source and object type
          used for the import.
        </p>
      </SectionMessage>
      <br />
      <AssetSchemaSelect />
      <ImportSourceName defaultImportSourceName="OktaImport"/>
      <OktaImportConfiguration />
    </>
  );
};
export default OktaAssetStart;
